module.exports = __webpack_public_path__ + "media/images/top/feature_img_03-4d114faffd411f11624ba38d270bc96b.png";